// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-benefit{padding-bottom:1.25rem}.card-benefit .card-benefit__image{height:45px}.card-benefit .card-benefit__title{margin:1.25rem 0 .625rem;max-width:90%}.card-benefit .card-benefit__title_thin{margin:1.25rem 0 .625rem;max-width:90%;font-weight:400!important}.card-benefit .card-benefit__description{color:#51596c;line-height:1.5;max-width:90%}", ""]);
// Exports
module.exports = exports;
